import { withInstall } from '@antdv/utils';
import APopover from './src/Popover';

export const Popover = withInstall(APopover);
export default Popover;

export * from './src/props';
